var _g, _defs, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1244_8637)",
    mask: "url(#mask-powermask-path-effect9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.25 15c2.6924 0 4.875-2.1826 4.875-4.875 0-2.6924-2.1826-4.875-4.875-4.875-2.6924 0-4.875 2.1826-4.875 4.875 0 2.6924 2.1826 4.875 4.875 4.875z",
    fill: "#015BD7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#141046",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.25 15c2.6924 0 4.875-2.1826 4.875-4.875 0-2.6924-2.1826-4.875-4.875-4.875-2.6924 0-4.875 2.1826-4.875 4.875 0 2.6924 2.1826 4.875 4.875 4.875z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.569 5.4281c0.431-0.11689 0.8754-0.17677 1.3219-0.17813 1.293 0 2.5329 0.51361 3.4472 1.4278 0.9142 0.91424 1.4278 2.1542 1.4278 3.4472 0 1.2929-0.5136 2.5329-1.4278 3.4471-0.9143 0.9143-2.1542 1.4279-3.4472 1.4279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 18.506c0.7612-1.0832 1.7719-1.9673 2.9468-2.5777 1.1748-0.6103 2.4793-0.9289 3.8032-0.9289s2.6284 0.3186 3.8032 0.9289c1.1749 0.6104 2.1856 1.4945 2.9468 2.5777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.891 15c1.3241-8e-4 2.6288 0.3174 3.8038 0.9277 1.1749 0.6104 2.1855 1.4948 2.9462 2.5786"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1244_8637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-powermask-path-effect9",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mask-powermask-path-effect9_box",
    d: "m-0.5 3.25h25.141v17.256h-25.141z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.699,
    cy: 16.322,
    r: 5.9694,
    fill: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 5,
    strokeWidth: 3.6421
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.53009 0 0 .53009 10.749 11.554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.7375 11.512c-0.32512-0.7976-0.49074-1.6512-0.4875-2.5125 0-1.335 0.39588-2.6401 1.1376-3.7501 0.74172-1.11 1.7959-1.9752 3.0293-2.4861 1.2334-0.5109 2.5906-0.64457 3.9-0.38412 1.3093 0.26045 2.5121 0.90333 3.4561 1.8473 0.944 0.94401 1.5869 2.1467 1.8473 3.4561 0.2605 1.3094 0.1268 2.6666-0.3841 3.9s-1.3761 2.2876-2.4861 3.0293-2.4151 1.1376-3.7501 1.1376c-0.8613 0.0032-1.7149-0.1624-2.5125-0.4875l-1.2375 1.2375h-2.25v2.25h-2.25v2.25h-3.75v-3.75z",
    fill: "#015bd7",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7375 11.512c-0.32512-0.7976-0.49074-1.6512-0.4875-2.5125 0-1.335 0.39588-2.6401 1.1376-3.7501 0.74172-1.11 1.7959-1.9752 3.0293-2.4861 1.2334-0.5109 2.5906-0.64457 3.9-0.38412 1.3093 0.26045 2.5121 0.90333 3.4561 1.8473 0.944 0.94401 1.5869 2.1467 1.8473 3.4561 0.2605 1.3094 0.1268 2.6666-0.3841 3.9s-1.3761 2.2876-2.4861 3.0293-2.4151 1.1376-3.7501 1.1376c-0.8613 0.0032-1.7149-0.1624-2.5125-0.4875v0l-1.2375 1.2375h-2.25v2.25h-2.25v2.25h-3.75v-3.75z",
    stroke: "#141046",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.875 8.25c0.6213 0 1.125-0.50368 1.125-1.125s-0.5037-1.125-1.125-1.125-1.125 0.50368-1.125 1.125 0.5037 1.125 1.125 1.125z",
    fill: "#141046"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersKeyIcon);
export default __webpack_public_path__ + "static/media/users-key-icon.6fdc29c925c54574449b8c4674cef7ed.svg";
export { ForwardRef as ReactComponent };